import React, { useState } from 'react';

const DIRECTION_ICON = {
  tara:     '🕊',
  wealth:   '💰',
  health:   '🌿',
  obstacle: '🔥',
  anxiety:  '🍃',
};

function formatDatetime(dtStr, timezone) {
  if (!dtStr) return null;
  try {
    const dt = new Date(dtStr);
    const opts = {
      month: 'long', day: 'numeric',
      weekday: 'short',
      hour: '2-digit', minute: '2-digit',
      timeZone: timezone || 'America/Toronto',
      timeZoneName: 'short',
    };
    return dt.toLocaleString('zh-CN', opts);
  } catch {
    return dtStr;
  }
}

export default function EnergyMatchCard({ data, lang = 'zh' }) {
  const [dismissed, setDismissed] = useState(() => {
    try { return localStorage.getItem('lumina_energy_match_hidden') === '1'; }
    catch { return false; }
  });

  if (!data || dismissed) return null;

  const zh = lang !== 'en';
  const narrative = zh ? data.narrative_zh : data.narrative_en;
  const dirLabel  = zh ? data.direction_label_zh : data.direction_label_en;
  const icon = DIRECTION_ICON[data.matched_direction] || '✨';

  const activity = data.activity;
  const fallback = data.fallback;

  function handleDismiss() {
    try { localStorage.setItem('lumina_energy_match_hidden', '1'); } catch {}
    setDismissed(true);
  }

  const cardStyle = {
    maxWidth: 640,
    margin: '48px auto 32px',
    background: '#fff',
    border: '1.5px solid #D4AF37',
    borderRadius: 16,
    padding: '28px 32px',
    position: 'relative',
    fontFamily: "'Noto Serif SC', 'Noto Serif', Georgia, serif",
  };

  const pillStyle = {
    display: 'inline-block',
    background: 'rgba(212,175,55,0.12)',
    border: '1px solid rgba(212,175,55,0.4)',
    color: '#8B6914',
    borderRadius: 20,
    padding: '4px 14px',
    fontSize: 13,
    fontWeight: 600,
    letterSpacing: '0.04em',
    marginBottom: 16,
  };

  const narrativeStyle = {
    color: 'rgba(0,0,0,0.72)',
    fontSize: 15,
    lineHeight: 1.75,
    marginBottom: 20,
  };

  const activityCardStyle = {
    background: 'rgba(212,175,55,0.05)',
    border: '1px solid rgba(212,175,55,0.25)',
    borderRadius: 10,
    padding: '16px 20px',
    transition: 'box-shadow 0.2s, transform 0.2s',
    cursor: 'default',
  };

  const btnStyle = {
    display: 'block',
    width: '100%',
    marginTop: 14,
    padding: '10px 0',
    background: '#D4AF37',
    color: '#fff',
    border: 'none',
    borderRadius: 8,
    fontSize: 14,
    fontWeight: 600,
    letterSpacing: '0.06em',
    cursor: 'pointer',
    textAlign: 'center',
    textDecoration: 'none',
  };

  const dismissBtn = {
    position: 'absolute',
    top: 12, right: 14,
    background: 'none',
    border: 'none',
    color: 'rgba(0,0,0,0.28)',
    fontSize: 18,
    cursor: 'pointer',
    lineHeight: 1,
    padding: 0,
  };

  return (
    <div style={cardStyle}>
      <button style={dismissBtn} onClick={handleDismiss} title="关闭">×</button>

      {/* Header */}
      <p style={{ color: 'rgba(0,0,0,0.42)', fontSize: 12, letterSpacing: '0.08em', marginBottom: 10 }}>
        {zh ? '根据你的报告，我们注意到——' : 'Based on your report, we noticed —'}
      </p>

      {/* Direction pill */}
      <div style={pillStyle}>{icon} {dirLabel}</div>

      {/* Narrative */}
      <p style={narrativeStyle}>{narrative}</p>

      {/* Activity card — live event */}
      {activity && (
        <div style={activityCardStyle}>
          <p style={{ fontSize: 15, fontWeight: 700, color: 'rgba(0,0,0,0.82)', marginBottom: 4 }}>
            {icon} {zh ? activity.title_zh : activity.title_en}
          </p>
          <p style={{ fontSize: 13, color: 'rgba(0,0,0,0.55)', marginBottom: 2 }}>
            {zh ? activity.teacher_zh : activity.teacher_en}
            {zh ? ' 带领' : ' leading'}
          </p>
          {activity.datetime && (
            <p style={{ fontSize: 13, color: 'rgba(0,0,0,0.55)', marginBottom: 2 }}>
              {formatDatetime(activity.datetime, activity.timezone)}
            </p>
          )}
          <p style={{ fontSize: 12, color: 'rgba(0,0,0,0.42)', marginBottom: 0 }}>
            {zh ? activity.prerequisite_zh : activity.prerequisite_en}
          </p>
          <a href={activity.url} style={btnStyle}>
            {zh ? '预约席位' : 'Reserve a Seat'}
          </a>
        </div>
      )}

      {/* Fallback — evergreen */}
      {!activity && fallback && (
        <div style={activityCardStyle}>
          <p style={{ fontSize: 15, fontWeight: 700, color: 'rgba(0,0,0,0.82)', marginBottom: 4 }}>
            {icon} {zh ? fallback.title_zh : fallback.title_en}
          </p>
          <p style={{ fontSize: 13, color: 'rgba(0,0,0,0.55)', marginBottom: 2 }}>
            {zh ? fallback.teacher_zh : fallback.teacher_en}
          </p>
          <p style={{ fontSize: 13, color: 'rgba(0,0,0,0.55)', marginBottom: 2 }}>
            {zh ? fallback.schedule_zh : fallback.schedule_en}
          </p>
          <p style={{ fontSize: 12, color: 'rgba(0,0,0,0.42)', marginBottom: 0 }}>
            {zh ? fallback.prerequisite_zh : fallback.prerequisite_en}
          </p>
          <a href={fallback.url} style={btnStyle}>
            {zh ? '查看活动日历' : 'View Event Calendar'}
          </a>
        </div>
      )}
    </div>
  );
}
